import { useEffect } from "react";
import usePrevious from "utils/hooks/usePrevious";

const useFilterInactivitiesOutOfRangeWhenDateOrTimeChanges = ({
    duration,
    errors,
    change: {
        changeDurationOnlyDayFields,
        changeDurationManyDaysFields
    }
}) => {
    const { onlyDay, manyDays } = duration;
    const prevManyDays = usePrevious(manyDays);
    useEffect(() => {
        applyFilterInactivityItemsInOnlyDayDuration();
    }, [onlyDay.time.start, onlyDay.time.end]);
    useEffect(() => {
        if (!hasChangedDateOrTimeInManyDaysCase()) return;
        applyFilterInactivityItemsInManyDaysDuration();
    }, [prevManyDays]);
    useEffect(() => {
        applyFilterInactivityItemsInManyDaysDuration();
    }, [manyDays.date]);
    const applyFilterInactivityItemsInOnlyDayDuration = () => {
        changeDurationOnlyDayFields({
            ...onlyDay, 
            time: {
                ...onlyDay.time,
                inactivity: onlyDay.time.inactivity.filter(inactivityItem => filterInactivityItemOutOfRangeOfSchedule({
                    inactivityItem,
                    time: onlyDay.time
                }))
            }
        }, errors.onlyDay);
    }
    const hasChangedDateOrTimeInManyDaysCase = () => {
        if (!prevManyDays) return false;
        if (prevManyDays.date.start !== manyDays.date.start || prevManyDays.date.end !== manyDays.date.end) {
            return true;
        }
        if (manyDays.time.length === 0 || prevManyDays.time.length !== manyDays.time.length) 
            return false;
        const timeItemHasChanged = manyDays.time.some(({ dayId, start, end }) => {
            return prevManyDays.time.some(prevTime => {
                return prevTime.dayId === dayId && (prevTime.start !== start || prevTime.end !== end);
            });
        });
        if (!timeItemHasChanged) 
            return false;
        return true;
    }
    const applyFilterInactivityItemsInManyDaysDuration = () => {
        const newValue = {
            ...manyDays, 
            time: manyDays.time.map(timeItem => ({
                ...timeItem,
                inactivity: timeItem.inactivity
                    .filter(inactivityItem => filterInactivityItemOutOfRangeOfSchedule({
                        inactivityItem,
                        date: manyDays.date,
                        time: timeItem
                    }))
            }))
        };
        const newErrorValue = {
            ...errors.manyDays,
            time: errors.manyDays.time.map(timeErrorItem => {
                const timeItemOfCurrentDay = manyDays.time
                    .find(timeItem => timeItem.dayId === timeErrorItem.dayId);
                const indexesMustHasBeenRemoved = timeItemOfCurrentDay
                    .inactivity
                    .map((inactivityItem, idx) => {
                        if (!filterInactivityItemOutOfRangeOfSchedule({
                            inactivityItem,
                            date: manyDays.date,
                            time: timeItemOfCurrentDay
                        }))
                            return idx;
                        return null;
                    })
                    .filter(index => index !== null);
                return {
                    ...timeErrorItem,
                    inactivity: timeErrorItem.inactivity
                        .filter((_, idx) => !indexesMustHasBeenRemoved.includes(idx))
                };
            })
        };
        changeDurationManyDaysFields(newValue, newErrorValue);
    }
    const filterInactivityItemOutOfRangeOfSchedule = ({
        inactivityItem, date, time
    }) => {
        return (
            inactivityItem.time.start >= time.start && inactivityItem.time.end <= time.end &&
            (!date || (inactivityItem.date >= date.start && inactivityItem.date <= date.end))
        );
    }
}

export default useFilterInactivitiesOutOfRangeWhenDateOrTimeChanges;